export class CreateProjectRequest
{    
    public name: string;
    public description: string;
    public programId: string;
    public scenarioId: string;
}